export interface GameListItemServerData {
    game_id: string;
    name: string;
}

export interface StoreGamesResponse {
    games: GameListItemServerData[];
}

export interface GameListData {
    id: string;
    name: string;
}

class GameListModel {
    private _data: GameListItemServerData[];

    constructor(data: GameListItemServerData[] = []) {
        this._data = data;
    }

    get games(): GameListData[] {
        return this._data.map(item => ({
            id: item.game_id,
            name: item.name,
        }));
    }

    static fromServerData(data: StoreGamesResponse | null | undefined): GameListModel {
        return new GameListModel(data?.games ?? []);
    }

    static createEmpty(): GameListModel {
        return new GameListModel([]);
    }
}

export default GameListModel;
